export enum API {
  USER_GET_ONE = '/user/:id',
  CONTRACT_GET_ALL = '/contracts',
  REPAYMENT_OF_CONTRACT_GET_ALL = '/repayment/:contractNo',
};
